"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RubricsRadioGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RubricsRadioGroup_styled_1 = require("./RubricsRadioGroup.styled");
var Radio_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Radio/Radio.component");
var RubricsRadioButton_1 = require("../RubricsRadioButton/RubricsRadioButton");
var react_1 = require("react");
var api_1 = require("../../../../api");
var react_i18next_1 = require("react-i18next");
var RubricsRadioGroup = function (_a) {
    var optionsList = _a.optionsList, _b = _a.criteriaIndex, criteriaIndex = _b === void 0 ? 0 : _b, defaultValue = _a.defaultValue, isDisabled = _a.isDisabled, categoryId = _a.categoryId, criteriaId = _a.criteriaId, itemRubric = _a.itemRubric, _c = _a.isReadOnly, isReadOnly = _c === void 0 ? false : _c, curriculumId = _a.curriculumId, onCallBackSelection = _a.onCallBackSelection;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var customRubricService = (0, react_1.useContext)(api_1.ServiceContext).customRubricService;
    var _d = (0, react_1.useState)(null), defaultRadio = _d[0], setDefaultRadio = _d[1];
    var _e = (0, react_1.useState)([]), newOptionsList = _e[0], setNewOptionsList = _e[1];
    var _f = (0, react_1.useState)('unSelected'), selectedOption = _f[0], setSelectedOption = _f[1];
    var onSelectionChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var attemptRubricSelected, attemptRubricSelections, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(value !== selectedOption)) return [3 /*break*/, 4];
                    attemptRubricSelected = {
                        itemExternalId: itemRubric.itemExternalId,
                        externalQuestionId: itemRubric.externalQuestionId,
                        attemptId: itemRubric.attemptId,
                        criterionId: criteriaId,
                        categoryId: categoryId,
                        ratingId: value,
                        answerDoesNotApply: false,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, customRubricService.upsertAttemptRubricSelection(attemptRubricSelected, curriculumId)];
                case 2:
                    attemptRubricSelections = _a.sent();
                    setSelectedOption(value);
                    if (onCallBackSelection) {
                        onCallBackSelection(attemptRubricSelections.responses, criteriaId, value, criteriaIndex);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log('Error: ', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var initialize = (0, react_1.useCallback)(function () {
        var optionSelected = null;
        var optList = optionsList.map(function (_a) {
            var score = _a.score, value = _a.value, description = _a.description, isSelected = _a.isSelected, ratingId = _a.ratingId;
            if (isSelected) {
                optionSelected = ratingId;
            }
            return {
                value: ratingId,
                label: t('customRubrics.category.proficiencyTitle', {
                    label: (0, api_1.camelCaseToTitle)(value),
                    score: score,
                }),
                description: description,
            };
        });
        setNewOptionsList(optList);
        setSelectedOption(optionSelected);
        var defaultProficiency = defaultValue
            ? optionsList.findIndex(function (opt) { return opt.value === defaultValue; })
            : -1;
        setDefaultRadio(defaultProficiency + 1);
    }, [defaultValue, optionsList, t]);
    (0, api_1.useMount)(function () {
        initialize();
    });
    return ((0, jsx_runtime_1.jsx)(RubricsRadioGroup_styled_1.StyledRadioGroup, { defaultRadio: defaultRadio, children: selectedOption !== 'unSelected' && ((0, jsx_runtime_1.jsx)(Radio_component_1.RadioGroup, { orientation: "vertical", isDisabled: isDisabled, defaultValue: selectedOption, onChange: onSelectionChange, isReadOnly: isReadOnly, children: newOptionsList.map(function (_a) {
                var value = _a.value, label = _a.label, description = _a.description;
                return ((0, jsx_runtime_1.jsx)(RubricsRadioButton_1.RubricsRadioButton, { value: value, label: label, ariaLabel: "".concat(label, " ").concat(description || ''), description: description, isDefaultValue: value === defaultValue }, "".concat(criteriaId, "-").concat(value)));
            }) })) }));
};
exports.RubricsRadioGroup = RubricsRadioGroup;
exports.default = exports.RubricsRadioGroup;
